import React, { useEffect, useRef, useState } from "react";
import ReactDatePickerE from "components/date-picker/ReactDatePickerE";
import Printable from "../A4";
import { Button, Card, Col, Row } from "react-bootstrap";
import { TicketsAPI } from "api";
import BreadCrumb from "components/breadcrumb/BreadCrumb";

function TicketReport() {
  const printRef = useRef();

  const [allTickets, setAllTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);

  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  // Fetch tickets once
  useEffect(() => {
    const getData = async () => {
      try {
        const res = await TicketsAPI.get();
        const data = res?.data?.data || [];
        setAllTickets(data);
      } catch (error) {
        console.error(error);
      }
    };
    getData();
  }, []);

  // Filter automatically on date change
  useEffect(() => {
    if (!startDate || !endDate) {
      setFilteredTickets([]);
      return;
    }

    const filtered = allTickets.filter((ticket) => {
      const d = new Date(ticket.ticketDate);
      return (
        d >= new Date(startDate).setHours(0, 0, 0, 0) &&
        d <= new Date(endDate).setHours(23, 59, 59, 999)
      );
    });

    setFilteredTickets(filtered);
  }, [startDate, endDate, allTickets]);

  const totalAmount = filteredTickets.reduce(
    (sum, t) => sum + (t.amountPaid || 0),
    0,
  );

  return (
    <div className="ticket-report">
      <BreadCrumb />

      <Card className="shadow-sm border-0 rounded-3 mt-3">
        {/* Header */}
        <Card.Header className="bg-white border-bottom py-3">
          <Row className="align-items-center">
            <Col md>
              <h5 className="mb-2 mb-md-0">Ticket Report</h5>
            </Col>

            <Col md="auto">
              <div className="d-flex align-items-center gap-3">
                <div className="fw-medium">Date Range:</div>
                <div style={{ width: "250px" }}>
                  <ReactDatePickerE
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                  />
                </div>
              </div>
            </Col>

            {/* <Col xs="auto">
              <Button
                variant="success"
                className="fw-medium"
                onClick={() => printRef.current.handlePrint()}
              >
                Print
              </Button>
            </Col> */}
          </Row>
        </Card.Header>

        {/* Printable Table */}
        <Printable ref={printRef} documentTitle="Ticket Report">
          <div style={{ padding: 20, fontSize: "14px" }}>
            <div className="table-responsive">
              <table className="professional-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Ticket Number</th>
                    <th>Patient Name</th>
                    <th>Date</th>
                    <th className="text-end">Amount Paid</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTickets.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-4">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    filteredTickets.map((t, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{t.ticketNumber}</td>
                        <td>{t.patientName}</td>
                        <td>{new Date(t.ticketDate).toLocaleDateString()}</td>
                        <td className="text-end">
                          {formatAmount(t.amountPaid)}
                        </td>
                        <td>{t.status}</td>
                      </tr>
                    ))
                  )}
                </tbody>
                {filteredTickets.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan={4} className="fw-bold total-label">
                        Total
                      </td>
                      <td className="text-end fw-bold total-amount">
                        {formatAmount(totalAmount)}
                      </td>
                      <td className="total-label"></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        </Printable>
      </Card>

      {/* Professional Table Styles */}
      <style jsx>{`
        .professional-table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ccc;
        }

        .professional-table th,
        .professional-table td {
          padding: 12px 15px;
          border: 1px solid #ccc;
        }

        .professional-table thead {
          background-color: #f5f5f5;
          font-weight: 600;
          position: sticky;
          top: 0;
          z-index: 2;
          box-shadow: inset 0 -1px 0 #ddd;
        }

        .professional-table tbody tr:hover {
          background-color: #f1f7ff;
          transition: 0.2s;
        }

        .professional-table tbody tr:nth-child(even) {
          background-color: #fafafa;
        }

        .total-label {
          background-color: #f0f0f0;
          border-top: 2px solid #c0c0c0;
        }

        .total-amount {
          background-color: #f0f0f0;
          border-top: 2px solid #c0c0c0;
        }

        .text-end {
          text-align: right;
        }
      `}</style>
    </div>
  );
}

export default TicketReport;
